<template>
  <div class="home-page">
    <img src="../assets/face logo.png">

    <div class="title">
      Face Club COVID-19 Tracking
    </div>
    <div class="subtitle">
      Die Registration ermöglicht den Contact Tracing im Rahmen des Schutzkonzeptes der Face Club.
    </div>
    <add-user-visit
      @userNotExist="goToRegisterPage"
      @visitAdded="goToVisitSuccessPage"
    />
  </div>
</template>

<script>
  import AddUserVisit from "../components/AddUserVisit";

  export default {
    name: "HomePage",
    components: {AddUserVisit},
    methods: {
      goToRegisterPage(phone) {
        this.$router.push({
          name: "RegisterPage",
          query: {phone}
        });
      },
      goToVisitSuccessPage() {
        this.$router.push({
          name: "VisitSuccessPage",
        });
      },
    }
  };
</script>

<style lang="scss">
  @import "HomePage";
</style>
